import React from 'react';
import { ProductLine } from '@kouto/types';
import { PublicListingV3, HostedBy } from 'types/listingV3';
import useHosts from 'api/hosts/useHosts';
import { HostInfoBox } from './HostInfoBox';
import { EventInfoBox } from './EventInfoBox';
import { BrandInfoBox } from './BrandInfoBox';

interface ListingInfoBoxProps {
  dates?: Date[] | null;
  hostData?: HostedBy | null;
  productLine: PublicListingV3['productLine'];
  providerBrandName?: string | null;
}

export const ListingInfoBox = ({
  dates,
  hostData,
  productLine,
  providerBrandName,
}: ListingInfoBoxProps) => {
  // We can remove this once we are fully integrated with v3
  // We have this here because v2/listings only returns the host ID
  const { data: hostSWR, isLoading: hostLoading } = useHosts(
    hostData && hostData.id && !hostData.firstName ? [hostData?.id] : [],
  );

  const hostSwrData = hostSWR ? hostSWR[0] : null;

  if (providerBrandName) {
    return <BrandInfoBox providerBrandName={providerBrandName} />;
  }

  if (productLine === ProductLine.HOST && hostData && !hostLoading) {
    return (
      <HostInfoBox
        firstName={hostSwrData ? hostSwrData.firstName : hostData?.firstName}
        profilePicture={
          hostSwrData ? hostSwrData.profilePicture : hostData.profilePicture
        }
      />
    );
  }

  if (productLine === ProductLine.ACTIVATE && dates?.length) {
    return <EventInfoBox dates={dates} />;
  }

  return null;
};
